import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import ChangePasswordForm from './ChangePasswordForm';

/**
 * 强制修改密码弹框：用户数据 mustChangePwd === '1' 时弹出，
 * 必须修改密码后才可继续使用，修改成功后退出登录并跳转登录页重新登录。
 */
export default function ForcePasswordChangeModal() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user || user.mustChangePwd !== '1') return null;

  const handleChanged = async () => {
    // 稍作停留展示「已保存」状态，随后退出并要求重新登录
    setTimeout(async () => {
      await logout();
      navigate('/login');
    }, 1000);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md bg-background-100 rounded-2xl p-6 shadow-xl">
        <div className="flex items-start gap-3 mb-5">
          <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center shrink-0">
            <i className="ri-lock-password-line text-xl text-amber-600" />
          </div>
          <div>
            <h3 className="font-heading font-bold text-base text-foreground-950 mb-1">请修改初始密码</h3>
            <p className="text-xs text-foreground-500 leading-relaxed mb-1">
              为保障账号安全，首次登录须修改初始密码。修改完成后将退出登录，请使用新密码重新登录。
            </p>
            <p className="text-xs text-foreground-500 leading-relaxed mb-1">请确保密码长度为 8 至 16 位，必须包含大小写字母、数字和特殊字符</p>
          </div>
        </div>
        <ChangePasswordForm showTitle={false} onSuccess={handleChanged} />
      </div>
    </div>
  );
}
